import { render, staticRenderFns } from "./tail_menu.vue?vue&type=template&id=b1907626&scoped=true"
import script from "./tail_menu.vue?vue&type=script&lang=js"
export * from "./tail_menu.vue?vue&type=script&lang=js"
import style0 from "./tail_menu.vue?vue&type=style&index=0&id=b1907626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1907626",
  null
  
)

export default component.exports